<div
  class="container flex column align-items-center"
  *ngIf="!isOffState()"
  [ngClass]="{
    'pre-live': isPreLiveState(),
    live: isLiveState(),
    off: isOffState(),
    'justify-center': isLiveState() || isOffState(),
    'justify-evenly': isPreLiveState(),
  }"
  (mouseover)="onMouseOver()"
  [title]="getStateDescription()"
  (click)="isPreLiveState() || isLiveState() ? navigateToBroadcastEdit() : null"
  [style.cursor]="
    isBroadcastsManager && (isPreLiveState() || isLiveState()) ? 'pointer' : 'default'
  "
>
  <div class="flex row label" *ngIf="!isOffState()">LIVE</div>
  <div class="flex row counter" *ngIf="state === EChannelBroadcastMode.PreLive">
    {{ timeLeftForLiveBroadcastingFormatted() }}
  </div>
  <div class="flex row channel-name" *ngIf="showChannelName">
    {{ channelName }}
  </div>
</div>
